import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeStep } from "../../features/formStepper.slice";
import PrimaryButton from "../ui/buttons/primaryButton";
import { Report } from "../../libs/loggers";

function ReviewAndSubmit() {
  const dispatch = useDispatch();
  const formStepper = useSelector((state) => state.formStepper.value);
    const page = window.location.pathname.replace(/^\/|\/$/g, '');
  const submitionId = useSelector(
    (state) => state.submition.submition?.submitionId
  );
  const userId = useSelector((state) => state.submition.data?.userId);

  useEffect(() => {
    const eventInfo = {
      action: "view",
      category: "step4_formstep_view",
      description: "viewed a form step in step 4",
      value: {
        currentPage: page,
        stepSlug:"review_and_submit",
        activeFormStep: formStepper?.step,
      },
    };

   
    Report(eventInfo, userId, submitionId);
  }, []); 

  const NavButtons = (props) => (
    <Box display="flex" justifyContent={"flex-end"}>
      <PrimaryButton
        disabled={props.isFirstStep}
        onClick={() => handleBack()}
        sx={{ mt: 1, mr: 1 }}
      >
        Back
      </PrimaryButton>
    </Box>
  );

  const handleBack = () => {
    const newStep = formStepper.step - 1;
    dispatch(changeStep(newStep));
  };
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={12}>
        <Typography sx={{ ml: 1 }}>
          Please go through all of your details and documentation provided above
          and ensure that they are correct. If you are happy to proceed, click
          on 'SUBMIT'.
        </Typography>
      </Grid>
      <Grid item xs={12} md={12}>
        <NavButtons isLastStep={true} isFirstStep={false} index={0} />
      </Grid>
    </Grid>
  );
}

export default ReviewAndSubmit;
